<template>
  <date-range-picker
    ref="picker"
    class="date-time-picker-pane"
    :show-day-num="false"
    @startSelected="handleSelect"
    @endSelected="handleSelect"
  >
    <div
      slot="right"
      class="date-time-picker-pane__right"
    >
      <div class="date-time-picker-pane__right-inner">
        <div class="date-time-picker-pane__right-time">
          <picker-time
            title="From"
            @time-change="handleTimeChange($event, 0)"
          />
          <div>至</div>
          <picker-time
            title="To"
            @time-change="handleTimeChange($event, 1)"
          />
        </div>
        <div class="date-time-picker-pane__right-button">
          <k-button
            type="grey"
            plain
            hover-mode="primary"
            @click="handleClear"
          >
            清空
          </k-button>
          <k-button
            type="primary"
            @click="handleConfirm"
          >
            确定
          </k-button>
        </div>
      </div>
    </div>
  </date-range-picker>
</template>

<script>
import DateRangePicker from '../date-picker/pickers/DateRangePicker'
import Button from '../button'
import PickerTime from './PickerTime.vue'

export default {
  name: 'KDateTimePickerPane',
  provide() {
    return {
      context: this.context, // 必须当前值为响应式才可以传递为响应式
    }
  },
  components: {
    DateRangePicker,
    KButton: Button,
    PickerTime,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    precision: {
      type: String,
      default: 'minute', // 'second', 'minute', 'hour'
    },
  },
  data() {
    return {
      context: {
        unlinkViews: false,
        precision: this.precision,
        value: this.value,
      },
      dateTime: [],
    }
  },
  mounted() {
    this.$refs.picker.locateViews()
    this.dateTime = [...this.value]
  },
  methods: {
    handleSelect() {
      const { startValue, endValue, value } = this.$refs.picker
      const [valS, valE] = value
      if ((startValue && !endValue && !valS && valE) || (!startValue && endValue && valS && !valE)) {
        return
      }
      this.context.value.splice(0, 1, startValue)
      this.context.value.splice(1, 1, endValue)
    },
    handleConfirm() {
      this.$emit('date-time-change', this.dateTime)
    },
    handleClear() {
      this.$emit('clear')
    },
    handleTimeChange(value, index) {
      this.dateTime[index] = value
    },
  },
}
</script>

<style lang="scss">
.date-time-picker-pane {
  &__right {
    height: 318px;
    width: 220px;
    margin-left: 16px;
    border-left: 1px solid rgba(226,228,238,0.48);
    padding-top: 8px;
    padding-left: 15px;
    &-inner {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    &-time {
      margin-top: 20px;
      & > div:nth-child(2){
        text-align: center;
        color: #7A7F99;
        margin: 16px 0;
      }
    }
    &-button {
      height: 30px;
      position: relative;
      margin-top: 48px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 20px;
      .km-button {
        min-width: 68px;
      }
    }
  }
}
</style>
